<template>
<div>
    <vapp-header btnMenu></vapp-header>

    <flash-message transitionIn="animated swing"></flash-message>

    <!-- Carousel for graphs and pie charts -->
    <carousel class="dashboard-charts chart-container" :perPage="1">
        <slide>
            <div class="dashboard-charts-title mt-2">Income & Expenses Trend</div>
            <div id="trendChart" class="col-12 mt-3 chart"></div>
        </slide>
        <!--<slide>-->
            <!--<div class="dashboard-charts-title mt-2">Income (Last 90 days)</div>-->
            <!--<div id="incomeChart" class="col-12 chart" style="margin-top: -15px"></div>-->
        <!--</slide>-->
        <slide>
            <div class="dashboard-charts-title mt-2">Bank / Cash Balance</div>
            <div id="balanceChart" class="col-12 chart"></div>
        </slide>
    </carousel>

    <div class="dashboard-others">

        <!-- Shortcut -->
        <div class="">
            <!--<div class="mt-3 ml-3 breakdown-title">-->
                <!--Shortcut-->
            <!--</div>-->
            <div class="mt-1 row mx-2">
                <div class="col-6 p-1">
                    <span class="" @click="contactConfirmationDialog">
                        <router-link to="/">
                        <div class="shortcut shortcut-contacts">
                            <div class="shortcut-container">
                                <img src="@/assets/images/ic_add_contacts.svg" class="shortcut-icon" align="middle">
                                <div class="shortcut-title">Add <span>Contact</span></div>
                            </div>
                        </div>
                    </router-link>
                    </span>
                </div>
                <div class="col-6 p-1">
                    <router-link to="create_invoice">
                        <div class="shortcut shortcut-invoices">
                            <div class="shortcut-container">
                                <img src="@/assets/images/ic_add_invoices.svg" class="shortcut-icon" align="middle">
                                <div class="shortcut-title">Add <span>Invoices</span></div>
                            </div>
                        </div>
                    </router-link>
                </div>
                <!--<div class="col-4 p-1">-->
                    <!--<router-link to="create_item">-->
                        <!--<div class="shortcut shortcut-items">-->
                            <!--<div class="shortcut-container">-->
                                <!--<img src="@/assets/images/ic_add_items.svg" class="shortcut-icon" align="middle">-->
                                <!--<div class="shortcut-title">Add <span>Items</span></div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</router-link>-->
                <!--</div>-->
            </div>
        </div>

        <!-- Breakdown -->
        <div class="mt-2">
            <div class="mt-2 ml-3 breakdown-title">
                Invoice Overview
            </div>
            <div class="mt-2 col-12 row" style="margin-left: 0px;">
                <div class="col-4 p-0 pr-1 col-breakdown">
                    <md-card class="col-12">
                        <div class="pt-1 breakdown-title">Overdue</div>
                        <div class="pt-1 breakdown-amount breakdown-amount-overdue overflow-wrap">{{ overdueTotal }}</div>
                        <div class="pt-1 pb-1 breakdown-desc">{{ overdueNo }}</div>
                    </md-card>
                </div>
                <div class="col-4 p-0 px-1 ol-breakdown">
                    <md-card class="col-12">
                        <div class="pt-1 breakdown-title">Open</div>
                        <div class="pt-1 breakdown-amount breakdown-amount-open overflow-wrap">{{ openTotal }}</div>
                        <div class="pt-1 pb-1 breakdown-desc">{{ openNo }}</div>
                    </md-card>
                </div>
                <div class="col-4 p-0 pl-1 ol-breakdown">
                    <md-card class="col-12">
                        <div class="pt-1 breakdown-title">Received</div>
                        <div class="pt-1 breakdown-amount breakdown-amount-paid overflow-wrap">{{ receivedTotal }}</div>
                        <div class="pt-1 pb-1 breakdown-desc">{{ receivedNo }}</div>
                    </md-card>
                </div>
            </div>
        </div>

        <!-- Invoice summary -->
        <div class="mt-3 mb-3">
            <md-card class="mt-3" style="margin-left: 15px; margin-right:15px">
                <md-card-header class="invoice-summary-header">
                    <div class="md-title invoice-summary-title"><u><b>Last 30-days Invoice Summary</b></u></div>
                </md-card-header>

                <md-card-content class="invoice-summary-content">
                    <div class="row">
                        <div class="col-7">
                            <div class="invoice-total overflow-wrap">{{ invoiceSummaryTotal }}</div>
                            <!--<div v-bind:class="['mt-2', { 'invoice-total-positive' : invoiceSummaryPercentagePositive }, { 'invoice-total-negative' : !invoiceSummaryPercentagePositive }]">{{ invoiceSummaryPercentage }}</div>-->
                        </div>
                        <div class="col-5">
                            <div class="invoice-total-issued">{{ invoiceSummaryNo }}</div>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>

    </div>

</div>
</template>

<script>

    import ApexCharts from 'apexcharts'
    import moment from 'moment';

export default {
    data() {
        return {
            snapshot: null,
            balance: null,
            cashflow: null,
            expense: null,
            income: null,
            outstanding: null,
            trend: null,
            pwa_dashboard: null,
            invoiceSummaryTotal: "",
            invoiceSummaryPercentage: "",
            invoiceSummaryPercentagePositive: true,
            invoiceSummaryNo: "",
            overdueTotal: "",
            overdueNo: "",
            openTotal: "",
            openNo: "",
            receivedTotal: "",
            receivedNo: ""
        }
    },
    mounted() {
        console.log("Mounted : Main/Dashboard");
        this.$root.$emit('dashboard-init');

        //Get all companies from $store
        var company = this.$store.state.company.selectedCompany;

        //Set company_id to first company in array
        this.company_id = company

        //Use snapshot/{business_id} to get business snapshot
        this.$root.$emit('show-loading', true);
        this.axios({
            method: 'get',
            url: 'snapshot',
            params: {
                business_id: this.company_id,
            },
        })
                .then(response => {

            this.$root.$emit('show-loading', false);

        this.snapshot = JSON.parse(JSON.stringify(response.data));
        this.balance = this.snapshot.balance;
        this.cashflow = this.snapshot.cashflow;
        this.expense = this.snapshot.expense;
        this.income = this.snapshot.income;
        this.outstanding = this.snapshot.outstanding;
        this.trend = this.snapshot.trend;
        this.pwa_dashboard = this.snapshot.pwa_dashboard;

        var currencySymbol = this.pwa_dashboard.currency_symbol;
        this.invoiceSummaryTotal = currencySymbol + this.$numberWithCommas(this.pwa_dashboard.invoice["30_days_invoice_amount"]);
        this.invoiceSummaryPercentage = this.pwa_dashboard.invoice.percentage + "%";
        this.invoiceSummaryPercentagePositive = this.pwa_dashboard.invoice.percentage >= 0;

        var invoiceSummaryNo = this.pwa_dashboard.invoice["30_days_total_invoice"];
        this.invoiceSummaryNo = invoiceSummaryNo == 1 ? invoiceSummaryNo + " Invoice Issued" : invoiceSummaryNo + " Invoices Issued";
        this.overdueTotal = currencySymbol + this.$numberWithCommas(this.pwa_dashboard.invoice.invoice_overdue_amount);
        this.overdueNo = this.pwa_dashboard.invoice.invoice_overdue == 1 ? this.pwa_dashboard.invoice.invoice_overdue + " invoice" : this.pwa_dashboard.invoice.invoice_overdue + " invoices";
        this.openTotal = currencySymbol + this.$numberWithCommas(this.pwa_dashboard.invoice.invoice_open_amount);
        this.openNo = this.pwa_dashboard.invoice.invoice_open == 1 ? this.pwa_dashboard.invoice.invoice_open + " invoice" : this.pwa_dashboard.invoice.invoice_open + " invoices";
        this.receivedTotal = currencySymbol + this.$numberWithCommas(this.pwa_dashboard.invoice.invoice_received_amount);
        this.receivedNo = this.pwa_dashboard.invoice.invoice_received == 1 ? this.pwa_dashboard.invoice.invoice_received + " invoice" : this.pwa_dashboard.invoice.invoice_received + " invoices";

        this.renderTrendChart();
        this.renderIncomeChart();
        this.renderBalanceChart();

        })
        .catch(error => {
            this.$root.$emit('show-loading', false);
        this.$generalAPIErrorHandling(error, this.$router);
        });
    },
    methods: {
        prettyTitle(title) {
            return title.replace(/_/g, " ");
        },
        dataFormat: function(a, b) {
            if(b) return b + "%";
            return a;
        },
        renderTrendChart() {
                var categories = [];
                var incomeData = [];
                var expenseData = [];

                if (this.trend.periods) {
                    for (var i = 0; i < this.trend.periods.length; i++) {
                        var period = this.trend.periods[i];
                        categories.push(moment(period.month, 'YYYY-MM').format('MMM YY'));
                        incomeData.push(period.income);
                        expenseData.push(period.expense);
                    }
                }

                var options = {
                    chart: {
                        type: 'area',
                        toolbar: {
                            show: false,
                        },
                    },
                    series: [
                        {
                            name: 'Income',
                            data: incomeData
                        },
                        {
                            name: 'Expense',
                            data: expenseData
                        }],
                    xaxis: {
                        categories: categories
                    },
                    colors:['#5ec5c5', '#ed708f'],
                    grid: {
                        show: true,
                        borderColor: '#bfbfbf',
                    },
                    legend: {
                        position: 'top',
                        fontSize: '12px',
                        fontFamily: '12px',
                        markers: {
                            width: 30,
                            height: 12,
                            strokeWidth: 0,
                            strokeColor: '#fff',
                            radius: 0,
                        },
                    },
                    markers: {
                        size: 5,
                        hover: {
                            size: 9
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                }

                var chart = new ApexCharts(document.querySelector("#trendChart"), options);

                chart.render();

        },
        renderIncomeChart() {
                var amounts = [];
                var names = [];
                var colors = [];
                var options = null;

                if (this.income.categories) {
                    for (var i = 0; i < this.income.categories.length; i++) {
                        var category = this.income.categories[i];
                        amounts.push(Math.abs(category.amount));
                        names.push(category.name);
                        colors.push(this.hslToHex((360 * i / this.income.categories.length), 70, 65));
                    }
                }
                else {
                    amounts.push(100);
                    names.push("EMPTY");
                    colors.push("#DCDCDC");
                }

                options = {
                    chart: {
                        type: 'pie',
                        height: 260,
                        toolbar: {
                            show: false,
                        },
                    },
                    series: amounts,
                    labels: names,
                    colors: colors,
                    legend: {
                        fontSize: '2px',
                        fontFamily: '2px',
                        position: 'bottom',
                        show:false
                    },
                    zoom: {
                        enabled: true,
                        type: 'x',
                        autoScaleYaxis: false,
                        zoomedArea: {
                            fill: {
                                color: '#90CAF9',
                                opacity: 0.4
                            },
                            stroke: {
                                color: '#0D47A1',
                                opacity: 0.4,
                                width: 1
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                        position:'topRight',
                        style: {
                            fontSize: '5px'
                        },
                    },
                    dataLabels: {
                        enabled: false,
                        formatter: function(val, opt) {
                            if (names[opt.seriesIndex] !== "EMPTY") {
                                return names[opt.seriesIndex] + ' : ' + amounts[opt.seriesIndex] ;
                            } else {
                                return "";
                            }
                        },
                        style: {
                            colors: ['#333']
                        },
                        position: 'right'
                    },
                    responsive: [
                        {
                            breakpoint: 330,
                            options: {
                                plotOptions: {
                                    pie: {
                                        size: 80,
                                    }
                                },
                            }
                        },
                        {
                            breakpoint: 415,
                            options: {
                                plotOptions: {
                                    pie: {
                                        size: 100,
                                    }
                                },
                            }
                        }
                    ]
                };
                // var chart = new ApexCharts(document.querySelector("#incomeChart"), options);
                //
                // chart.render();
        },
        dynamicSort(property) {
            var sortOrder = 1;
            if(property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a,b) {
                /* next line works with strings and numbers,
                 * and you may want to customize it to your needs
                 */
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        },
        renderBalanceChart() {
                var balances = [];
                var names = [];
                var colors = [];

                var arrBalance = this.balance.accounts;
                arrBalance.sort(this.dynamicSort("balance"));

                arrBalance.slice(Math.max(arrBalance.length - 5, 1));
                this.balance.accounts.slice(Math.max( this.balance.accounts.length - 5, 1))

                if (this.balance.accounts.length > 0) {
                    for (var i = 0; i < this.balance.accounts.length; i++) {
                        var account = this.balance.accounts[i];
                        if (account.balance > 0){
                            balances.push(account.balance);
                            names.push(account.name);
                            colors.push(this.hslToHex((360 * i / this.balance.accounts.length), 70, 65));
                        }
                    }
                }

                if (balances.length > 5) {
                    balances.shift();
                    names.shift();
                    colors.shift();
                }

                var options = {
                    chart: {
                        type: 'bar',
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            distributed: true,
                            horizontal: false,
                            dataLabels: {
                                position: 'bottom'
                            },
                        }
                    },
                    series: [{
                        name: 'Balance',
                        data: balances
                    }],
                    xaxis: {
                        categories: names,
                        labels: {
                            show: false,
                            formatter: function(val) {
                                return val;
                            },
                            showDuplicates: true,
                            trim: true,
                        },
                        title: {
                            text: 'Account Balance'
                        }
                    },
                    colors: colors,
                    dataLabels: {
                        enabled: false
                    },
                };

                var chart = new ApexCharts(document.querySelector("#balanceChart"), options);

                chart.render();
        },

        hslToHex(h, s, l) {
            h /= 360;
            s /= 100;
            l /= 100;
            let r, g, b;
            if (s === 0) {
                r = g = b = l; // achromatic
            } else {
                const hue2rgb = (p, q, t) => {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                    if (t < 1 / 2) return q;
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                    return p;
                };
                const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                const p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            const toHex = x => {
                const hex = Math.round(x * 255).toString(16);
                return hex.length === 1 ? '0' + hex : hex;
            };
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        },

        contactConfirmationDialog() {
            this.$optionsToast("Add Contact", "Which type of contact you want to create?", this.routeToCreatePerson, this.routeToCreateBusiness , 'Business', 'Person');
        },
        routeToCreatePerson() {
            this.$router.push({ name: 'createPerson', params: {}})
        },
        routeToCreateBusiness() {
            this.$router.push({ name: 'createBusiness', params: {}})
        },
    },
}
</script>
